/**
 * Roster slot counts for a team, derived from its members and settings.
 *
 * GET /teams/:id/roster returns the member list (no summary), so the
 * approve-join dialog showed "?/? slots". Build the summary on the client.
 *
 * @returns {{ primaryCount, substituteCount, totalActive, maxPrimary, maxSubstitutes }}
 */
export function buildRosterSummary(team, members) {
  const active = (Array.isArray(members) ? members : []).filter(
    (m) => (m?.status || "active") === "active"
  );
  const substituteCount = active.filter((m) => m.member_type === "substitute").length;
  const primaryCount = active.length - substituteCount;

  const settings = team?.settings && typeof team.settings === "object" ? team.settings : {};
  const rules = team?.rules || settings.rules || {};
  const toInt = (v) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) && n >= 0 ? n : null;
  };

  const maxPrimary =
    toInt(team?.max_members) ?? toInt(settings.max_members) ?? Math.max(primaryCount, 0);
  const maxSubstitutes =
    toInt(team?.max_substitutes) ??
    toInt(settings.max_substitutes) ??
    toInt(rules.substitutions) ??
    0;

  return {
    primaryCount,
    substituteCount,
    totalActive: active.length,
    maxPrimary,
    maxSubstitutes,
  };
}

export default buildRosterSummary;
